function initDynamicSidebarTitle(): void {
  const sidebarTitle = document.querySelector<HTMLElement>(
    ".menu--desktop__title",
  );
  const firstMenuItem =
    document.querySelector<HTMLLIElement>("#menu-main-menu li");

  if (!sidebarTitle || !firstMenuItem) {
    return;
  }

  if (firstMenuItem.classList.contains("menu__item--parent")) {
    sidebarTitle.remove();
  }
}

export { initDynamicSidebarTitle };
